/**
 * Etat de la cloture cultures cote Agribilan, pour l'annee de recolte
 * selectionnee.
 *
 * L'endpoint `cloture/{annee}/verrouillage` renvoie deux drapeaux qui ne disent
 * pas la meme chose et qu'il est facile de confondre :
 *
 *  - `hasCloture` : un cout de production existe sur cette annee de recolte.
 *  - `isAtelierVerrouille` : ce cout de production est verrouille, donc les
 *    cultures ne sont plus modifiables du tout.
 *
 * Entre les deux, il y a la fenetre qui nous interesse : une cloture est ouverte
 * et les cultures restent modifiables, mais toucher a une culture se repercute
 * sur la saisie du cout de production. C'est la, et seulement la, qu'on previent
 * l'utilisateur.
 */

/**
 * Une cloture est en cours et les cultures sont encore modifiables.
 *
 * Une fois l'atelier verrouille, l'avertissement n'a plus lieu d'etre : les
 * modifications sont deja bloquees, et chaque bouton porte son propre message.
 *
 * @param {object} atelierCultureVerrouillage reponse de l'endpoint verrouillage
 * @returns {boolean} vrai s'il faut avertir l'utilisateur
 */
export function hasClotureEnCoursModifiable (atelierCultureVerrouillage) {
  return atelierCultureVerrouillage?.hasCloture === true &&
    atelierCultureVerrouillage?.isAtelierVerrouille !== true
}

export default hasClotureEnCoursModifiable
